var render = function render(){var _vm=this,_c=_vm._self._c;return _c('web-sec-map',{attrs:{"country":_vm.$store.state.country,"layer":_vm.$store.state.layer,"week":_vm.$store.state.week,"controls":true,"map_filter":_vm.$store.state.map_filter}})
}
var staticRenderFns = []

export { render, staticRenderFns }